import { Button, Divider, Grid, Paper, TextField } from "@mui/material";
import imgBusmen from '../img/busmen.PNG'
import { useContext, useState } from "react";
import {
    COLORS,
    DATA_USER,
    INIT_DATA_USER, NAME_FILE,
    TEXT_ALERT,
    TEXT_BTN,
    TEXT_PRE_ORDEN, TYPE_THEME,
    TYPES_ALERTS
} from "../Constants/Const";
import { TransitionAlerts } from "../Global/AlertComonent";
import { AuthContext } from "../Global/AuthContext";
import { encryptText, promiseServer} from "../Constants/Miselanea/FunctionsGlobals";


export function LoginUser(){

    const {log, theme} = useContext(AuthContext)

    const [dataUser, setDataUser] = useState(INIT_DATA_USER);

    const handlingDataUser = (type) => (eventComponent) =>{
        
        setDataUser({
            ...dataUser,
            [type]: eventComponent.target.value
        })
    }
    
    const handlingLogin = async () => {
        if (dataUser[DATA_USER.user] === '' || dataUser[DATA_USER.pws] === '') {
            TransitionAlerts({open: true, message: TEXT_ALERT.empy, typeAlert: TYPES_ALERTS.warning});
            return;
        }

        let params = {
            id_usuario: dataUser[DATA_USER.user],
            contrasena: dataUser[DATA_USER.pws]
        }
        let request = await promiseServer(NAME_FILE.logIn,params);
        let data ={
            ...request.datos[0],
            token: encryptText(dataUser[DATA_USER.pws])
        }
        log(data);
        if(request.respuesta === 'exito'){
            TransitionAlerts({
                open: true,
                message: request.mensaje,
                typeAlert: TYPES_ALERTS.success
            })

        }else{
            TransitionAlerts({
                open: true,
                message: request.mensaje,
                typeAlert: TYPES_ALERTS.warning
            })
        }

    }


    return(
        <Grid container style={{height: '100vh', backgroundColor: theme.MUI === TYPE_THEME.light? COLORS.blue:COLORS.blue_t1}}>
            <Grid item xs={12} container
                direction="column"
                justifyContent="center"
                alignItems="center">
                    <img src={imgBusmen} alt="BUSMEN LOGO" width={'170vh'} height={'65vh'}/>
                    <Grid item xs="auto" mt={2} p={2}>
                        <Paper elevation={12} style={{padding: "1vh"}}>                
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label={TEXT_PRE_ORDEN.tf_user}
                                name="email"
                                autoFocus
                                value={dataUser[DATA_USER.user]}
                                onChange={handlingDataUser(DATA_USER.user)}/>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label={TEXT_PRE_ORDEN.tf_pwd}
                                type="password"
                                id="password"
                                value={dataUser[DATA_USER.pws]}
                                onChange={handlingDataUser(DATA_USER.pws)}/>

                            <Divider style={{margin: "1vh"}}/>

                            <Grid  item xs={12}
                                container
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="flex-end">
                                    <Button onClick={()=>setDataUser(INIT_DATA_USER)}>{TEXT_BTN.clear}</Button>
                                    <Button onClick={handlingLogin} >{TEXT_BTN.accepted}</Button>
                            </Grid>
                        </Paper>
                    </Grid>
            </Grid>
        </Grid>
    );
}